import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Eye } from 'lucide-react';
import { Button } from '@shared/ui/button';
import { usePlatformImpersonation } from '@features/platform/usePlatformImpersonation';
export function PlatformImpersonateButton({ organizationId, organizationName, size = 'sm', variant = 'outline', className, stopPropagation = false, }) {
    const { openAsOrganization, isImpersonating } = usePlatformImpersonation();
    return (_jsxs(Button, { type: "button", size: size, variant: variant, className: className ?? 'gap-1 border-sky-500/40 text-sky-200 hover:bg-sky-500/10', disabled: isImpersonating, onClick: (e) => {
            if (stopPropagation)
                e.stopPropagation();
            openAsOrganization(organizationId, organizationName);
        }, children: [_jsx(Eye, { className: "h-3.5 w-3.5" }), "Abrir como esta org"] }));
}
